import { render } from "./RecoveryPasswordPage.vue?vue&type=template&id=2f01e297"
import script from "./RecoveryPasswordPage.vue?vue&type=script&lang=js"
export * from "./RecoveryPasswordPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__